import React, { useEffect, useRef } from 'react';
import '../styles/PaymentModal.css';

const PaymentModal = ({
  show,
  total,
  paymentType,
  setPaymentType,
  paidAmount,
  setPaidAmount,
  change,
  error,
  onConfirm,
  onCancel,
  isProcessing
}) => {
  const paymentTypeRef = useRef(null);
  const paidAmountRef = useRef(null);
  const confirmBtnRef = useRef(null);

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        paymentTypeRef.current?.focus();
      }, 150);
    }
  }, [show]);

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    }
    if (e.key === 'Enter' && document.activeElement === confirmBtnRef.current) {
      e.preventDefault();
      onConfirm();
    }
  };

  const focusPaidAmount = () => {
    setTimeout(() => {
      paidAmountRef.current?.focus();
    }, 50);
  };

  const focusConfirmButton = () => {
    setTimeout(() => {
      confirmBtnRef.current?.focus();
    }, 50);
  };

  if (!show) return null;

  return (
    <div className="modal-backdrop" onKeyDown={handleKeyDown}>
      <div className="payment-modal" role="dialog" aria-modal="true">
        <h3>Payment</h3>
        <div className="modal-row">
          <label>Total:</label>
          <div className="value">{total} LKR</div>
        </div>

        <div className="modal-row">
          <label htmlFor="paymentType">Payment Type</label>
          <select
            ref={paymentTypeRef}
            id="paymentType"
            value={paymentType}
            onChange={(e) => setPaymentType(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') focusPaidAmount();
            }}
          >
            <option value="cash">Cash</option>
            <option value="card">Card</option>
            <option value="mixed">Mixed</option>
          </select>
        </div>

        <div className="modal-row">
          <label htmlFor="paidAmount">Amount Paid</label>
          <input
            ref={paidAmountRef}
            id="paidAmount"
            type="number"
            className="form-input"
            value={paidAmount || ''}
            onChange={(e) => setPaidAmount(Number(e.target.value))}
            onKeyDown={(e) => {
              if (e.key === 'Enter') focusConfirmButton();
            }}
          />
        </div>

        {paidAmount !== null && (
          <div className="modal-row">
            <label>Change</label>
            <div className="value">{change} LKR</div>
          </div>
        )}

        {error && <p className="modal-message error">{error}</p>}

        <div className="modal-actions">
          <button
            ref={confirmBtnRef}
            onClick={onConfirm}
            className="btn btn-primary"
          >
            Confirm & Print
          </button>
          <button
            onClick={onCancel}
            className="btn btn-secondary"
            disabled={isProcessing}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;